import './../../../../../auw_config/Resources/Private/Js/modules/lazysizes';

import "./../../../../../auw_config/Resources/Private/Js/services/browser-detect";
import "./../../../../../auw_config/Resources/Private/Js/services/doubletap";

import "./../../../../../auw_config/Resources/Private/Js/AuwScrollManager";

import "./../../../../../auw_config/Resources/Private/Js/modules/twitter-bootstrap";
import "./../../../../../auw_config/Resources/Private/Js/modules/scroll-to-top";
import "./../../../../../auw_config/Resources/Private/Js/modules/select";
import "./../../../../../auw_config/Resources/Private/Js/modules/file";
import "./../../../../../auw_config/Resources/Private/Js/modules/responsive-table";
import "./../../../../../auw_config/Resources/Private/Js/modules/RTEcolorFix";
import "./../../../../../auw_config/Resources/Private/Js/modules/navigationDropdown";

import "./../../../../../auw_config/Resources/Private/Js/auw-extensions";
import "./../../../../../auw_config/Resources/Private/Js/modules/sticky-block";